<template>
  <div class="container">
    <SliderFile ></SliderFile>
    <div class="info-send" :class="{'info-send_visible': messageSend}">
      {{ messageSend }}
    </div>
    <div class="content-tabs">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a :class="[activeTab === 'tab1' ? 'active' : '', 'nav-link']" @click.prevent="checkTab('tab1')">
            Все отзывы ({{ numberReviews }})
          </a>
        </li>
        <li class="nav-item">
          <a :class="[activeTab === 'tab2' ? 'active' : '', 'nav-link']" @click.prevent="checkTab('tab2')">
            Вопросы по товару ({{ numberQuestions }})
          </a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div v-show="activeTab === 'tab1'">
          <ListReviews :user="user" :listReviews="listReviews" :statistics="statistics"
                       @loadReviews="loadReviews" @markModerate="markModerate" @deleteEntity="deleteEntity">
          </ListReviews>
        </div>
        <div v-if="dataInitialized" v-show="activeTab === 'tab2'">
          <ListQuestions :user="user" @updateNumberQuestions="updateNumberQuestions" @markModerate="markModerate"
                         @deleteEntity="deleteEntity">
          </ListQuestions>
        </div>
      </div>
    </div>
  </div>
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import ListReviews from "@/components/ListReviews";
import ListQuestions from "@/components/ListQuestions";
import responseImg from "@/assets/images/response-avatar.png";
import reviewImg2 from "@/assets/images/review-avatar.png";
import SliderFile from "@/components/SliderFile/SliderFile";
import eventBus from "@/js/eventBus";


import axios from 'axios';


export default {
  name      : 'App',
  components: {
    ListReviews,
    ListQuestions,
    SliderFile
  },
  data() {
    return {
      dataInitialized: false,
      forumData      : {
        product_id: 0
      },
      activeTab      : 'tab1',
      numberQuestions: 0,
      numberReviews: 0,
      user           : {
        uuid          : 'e34b8cce-36be-4f35-80e2-12f2590322f9',
        name          : 'Алексей',
        surname       : 'Кошовкин',
        authorizedUser: true,
        isModerator   : false,
        sessid        : ''
      },
      // динамические
      statistics : {
        rating       : 0,
        numberReviews: 0,
        stars        : [
          {
            code : 'stars5',
            value: 0,
          },
          {
            code : 'stars4',
            value: 0,
          },
          {
            code : 'stars3',
            value: 0,
          },
          {
            code : 'stars2',
            value: 0,
          },
          {
            code : 'stars1',
            value: 0,
          }
        ],
      },
      listReviews: [],
      messageSend: ''
    }
  },
  mounted() {
    this.init();
    this.loadData();
    this.dataInitialized = true;
    eventBus.$on('info', (message) => {
      this.messageSend = message;
      setTimeout(() => this.messageSend = '', 4000)
    })
  },
  methods: {
    getForumData() {
      return this.forumData;
    },
    //Метод получения данных форума
    init() {
      try {
        this.forumData = JSON.parse(document.getElementById('forum_id').innerHTML);
      } catch (e) {
        console.log(e);
      }
    },
    checkTab(tab) {
      this.activeTab = tab;
    },
    loadData() {
      const that = this;

      axios
          .get('/api/forum/v1/reviews/' + this.forumData.product_id + '/')
          .then(response => {
            if (
                response
                && response.data
            ) {
              that.user = response.data.data.user;
              that.listReviews = response.data.data.listReviews;
              that.numberReviews = Object.keys(response.data.data.listReviews).length;
              that.statistics = response.data.data.statistics;
            }
          });
    },
    updateNumberQuestions(number) {
      this.numberQuestions = number;
    },
    loadReviews() {
      const that = this;

      axios
          .get('/api/forum/v1/reviews/' + this.forumData.product_id + '/')
          .then(response => {
            if (
                response
                && response.data
            ) {
              that.listReviews = response.data.data.listReviews;
              that.statistics = response.data.data.statistics;
            }
          });
    },
    markModerate(uuid) {
      const formData = new FormData();

      formData.append('sessid', this.user.sessid);

      axios
          .post(
              '/api/forum/v1/moderate/' + uuid + '/',
              formData,
              {
                headers        : {
                  'Content-Type': 'multipart/form-data',
                },
                withCredentials: true
              }
          )
          .then(response => {
            if (
                response
                && response.data
                && response.data.result
            ) {
              return true;
            }
          });

      return false;
    },
    deleteEntity(uuid) {
      const formData = new FormData();
      formData.append('sessid', this.user.sessid);
      let that = this;
      axios
          .post(
              '/api/forum/v1/delete/' + uuid + '/',
              formData,
              {
                headers        : {
                  'Content-Type': 'multipart/form-data',
                },
                withCredentials: true
              }
          )
          .then(response => {
            if (
                response
                && response.data
                && response.data.result
            ) {
              that.loadData();

              return true;
            }
          });
    },
  }
}
</script>

<style></style>
